import { motion } from "framer-motion";

const ease = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, className = "", delay = 0, y = 40 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.9, delay, ease }}
  >
    {children}
  </motion.div>
);

export const MaskLines = ({ lines, className = "", lineClassName = "", delay = 0.15, as: Tag = "h1" }) => (
  <Tag className={className}>
    {lines.map((line, i) => (
      <span key={i} className="block overflow-hidden pb-[0.08em]">
        <motion.span
          className={`block ${lineClassName}`}
          initial={{ y: "110%", rotate: 2 }}
          animate={{ y: "0%", rotate: 0 }}
          transition={{ duration: 1.1, delay: delay + i * 0.12, ease }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </Tag>
);
